"use client";

import { useEffect, useRef, useState } from "react";

/** A running band's pause button (WCAG 2.2.2); src/styles/motion.css shows it only while the band runs. */
export default function BandPause() {
  const button = useRef<HTMLButtonElement>(null);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    button.current
      ?.closest("[data-re-band]")
      ?.toggleAttribute("data-re-band-paused", paused);
  }, [paused]);
  return (
    <button
      ref={button}
      type="button"
      data-re-band-pause=""
      onClick={() => setPaused((value) => !value)}
    >
      {paused ? "Afspil" : "Pause"}
    </button>
  );
}
